<template>
  <div class="settings">
    <h1>
      {{ $t("langcfg.txtLoginAccount") }} -
      <span style="font-size: 25px">({{ title }})</span>
    </h1>
    <div class="content">
      <el-form
        label-position="left"
        :model="userInfo"
        :style="isZHCN ? 'width: 600px' : 'width: 700px'"
        :label-width="isZHCN ? '200px' : '300px'"
      >
        <el-form-item
          class="form-item-margin-top"
          :label="`*${$t('langcfg.txtUserName')}: `"
          v-if="!isAddUser"
        >
          <div style="display: flex; align-items: center">
            <el-select v-model="userid" @change="userChanged">
              <el-option
                v-for="item in users"
                :key="item._id"
                :label="item.username"
                :value="item._id"
              ></el-option>
            </el-select>
            <span
              class="el-icon-delete"
              v-if="isadmin"
              style="font-size: 40px; margin-left: 10px"
              @click="delUser"
            ></span>
          </div>
        </el-form-item>

        <el-form-item
          v-else
          class="form-item-margin-top"
          :label="`*${$t('langcfg.txtUserName')}: `"
        >
          <el-input
            v-model="userInfo.username"
            @click.native.stop.prevent="handleClick('username')"
            @touchend.native.stop.prevent="handleClick('username')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!isAddUser"
          class="form-item-margin-top"
          :label="`*${$t('langcfg.txtOldPassword')}:`"
        >
          <el-input
            show-password
            v-model="userInfo.oldpassword"
            @click.native.stop.prevent="handleClick('oldpassword')"
            @touchend.native.stop.prevent="handleClick('oldpassword')"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="form-item-margin-top"
          :label="`*${isAddUser ? $t('langcfg.txtPassword') : $t('langcfg.txtNewPasswrod')}:`"
        >
          <el-input
            show-password
            v-model="userInfo.password"
            @click.native.stop.prevent="handleClick('password')"
            @touchend.native.stop.prevent="handleClick('password')"
          ></el-input>
        </el-form-item>

        <el-form-item class="form-item-margin-top" :label="`*${$t('langcfg.txtConfirmPassword')}:`">
          <el-input
            show-password
            v-model="userInfo.confirmpassword"
            @click.native.stop.prevent="handleClick('confirmpassword')"
            @touchend.native.stop.prevent="handleClick('confirmpassword')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isAddUser"
          class="form-item-margin-top"
          :label="`${$t('langcfg.txtRole')}:`"
        >
          <el-select v-model="userInfo.isadmin">
            <el-option
              v-for="item in roles"
              :key="item.value"
              :label="$t(`langcfg.${item.label}`)"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-margin-top">
          <div class="btn-area">
            <el-button @click="btnOKClick()" class="btn-operator"
              ><span style="font-size: 25px"> {{ $t("langcfg.txtOK") }}</span>
            </el-button>
            <a v-if="isAddUserVisible" class="change-add-user" @click="switchMode">{{
              changeAddLabel
            }}</a>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { Message, Size } from "../../../mixins";
import { getUsers, addUser, updateUser, delUser } from "../../../services/users";
import { saveServerSettings } from "../../../settings";
import { objectCopy } from "../../../shared/utils";
export default {
  data() {
    return {
      userInfo: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
        isadmin: "0"
      },
      isAddUserVisible: true,
      isAddUser: false,
      userid: "",
      users: {},
      roles: [
        {
          label: "txtAdministrator",
          value: "1"
        },
        {
          label: "txtCommonUser",
          value: "0"
        }
      ],
      isZHCN: false
    };
  },
  created() {
    if (window.session.user.isadmin === "0") {
      this.isAddUserVisible = false;
    }
  },
  methods: {
    normalLoginInfo(userid) {
      let uid = userid || this.userid;
      this.userInfo = {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
        isadmin: "0"
      };
      if (!this.isAddUser) {
        this.userInfo.isadmin = this.users[uid].isadmin;
        this.userInfo.username = this.users[uid].username;
      }
      this.userInfo = objectCopy(this.userInfo);
    },
    delUser() {
      if (this.userInfo.username === "") return;
      this.confirm(this.$t("langcfg.txtConfirm2DeleteUser"))
        .then(() => {
          delUser(this.userInfo.username, (error) => {
            if (error) {
              this.message(this.$t("langcfg.txtDeleteUserFailed"), "success");
            } else {
              this.message(this.$t("langcfg.txtDeleteUserSuccess"), "success");
            }
            this.getUsers(() => {
              this.normalLoginInfo();
            });
          });
        })
        .catch((e) => {});
    },
    userChanged(userid) {
      this.normalLoginInfo(userid);
    },
    switchMode() {
      this.isAddUser = !this.isAddUser;
      if (!this.isAddUser) {
        this.getUsers(() => {
          this.normalLoginInfo();
        });
      } else {
        this.normalLoginInfo();
      }
    },
    handleClick(key) {
      let self = this;

      this.$bus.$emit(EVENTS.spreadKeyBoard, self.userInfo[key], (value) => {
        self.userInfo[key] = value;
        self.userInfo = objectCopy(self.userInfo);
      });
    },
    getUsers(callback) {
      this.users = {};
      getUsers((error, users) => {
        this.users = {};
        if (error) {
          this.message(this.$t("langcfg.txtGetUserFailed"), "error");
        } else {
          users
            .filter((item) => {
              return (
                window.session.user.isadmin === "1" ||
                item.username === window.session.user.username
              );
            })
            .forEach((item) => {
              this.users[item._id] = item;
            });
          this.userid = window.session.user._id;
          if (callback) callback();
        }
      });
    },
    btnOKClick() {
      if (this.userInfo.password === "") {
        this.message(this.$t("langcfg.txtPasswordSholdNotBeEmpty"), "error");
        return;
      }
      if (this.userInfo.password !== this.userInfo.confirmpassword) {
        this.message(this.$t("langcfg.txtPasswordNotEqual"), "error");
        return;
      }
      if (this.isAddUser) {
        addUser(
          {
            username: this.userInfo.username,
            password: this.userInfo.password,
            isadmin: this.userInfo.isadmin
          },
          (error) => {
            if (error) {
              this.message(this.$t("langcfg.txtAddUserFailed"), "error");
            } else {
              this.message(this.$t("langcfg.txtAddUserSuccess"));
              this.$emit("re-login");
            }
          }
        );
      } else {
        updateUser(
          {
            sessionuser: window.session.user.username,
            username: this.userInfo.username,
            password: this.userInfo.password,
            oldpass: this.userInfo.oldpassword,
            isadmin: window.session.user.isadmin,
            userid: this.userid
          },
          (error) => {
            if (error) {
              this.message(this.$t("langcfg.txtChangePasswordFailed"), "error");
            } else {
              this.confirm(
                this.$t("langcfg.txtChangePasswordSuccess"),
                this.$t("langcfg.txtOK"),
                this.$t("langcfg.txtCancel")
              ).then(() => {
                window.localStorage.setItem("login-password", "");
                window.server.rememberPassword = false;
                saveServerSettings(window.server);
                this.$emit("re-login");
              });
            }
          }
        );
      }
    }
  },
  mounted() {
    this.getUsers(() => {
      this.normalLoginInfo();
    });
  },
  updated() {
    this.isZHCN = window.settings.language === "zh_CN";
  },
  computed: {
    isadmin() {
      return window.session.user.isadmin === "1" && this.userInfo.username !== "Admin";
    },
    changeAddLabel() {
      return this.isAddUser
        ? this.$t("langcfg.txtChangePassword")
        : this.$t("langcfg.txtAddAccount");
    },
    title() {
      return !this.isAddUser
        ? this.$t("langcfg.txtChangePassword")
        : this.$t("langcfg.txtAddAccount");
    }
  },
  mixins: [Size, Message]
};
</script>
<style scoped lang="less">
.settings {
  // margin-top: 60px;
  // margin-left: 30px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 800px;
}
.input-remember-password {
  padding-top: 0px;
  border: none;
  width: 25px;
  height: 25px;
}
.el-checkbox {
  margin: 0px;
  text-align: left;
}
.el-checkbox /deep/ .el-checkbox__label {
  color: white;
  font-size: 20px;
}
.el-checkbox /deep/ .el-checkbox__inner {
  width: 25px;
  height: 25px;
}

.el-checkbox /deep/ .el-checkbox__inner::after {
  height: 17px;
  width: 12px;
}
.el-checkbox /deep/ .el-checkbox__input {
  vertical-align: middle;
}

.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: 60px;
  width: 200px;
  font-size: 23px;
}
.btn-area {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
/deep/.el-form-item__label {
  color: white;
  font-size: 25px;
}
.change-add-user {
  color: @blue-selected-color;
  cursor: pointer;
  font-size: 25px;
  text-decoration: underline;
  width: 225px;
}
.form-item-margin-top {
  margin-top: 40px;
}
.content {
  padding-left: 40px;
  margin-top: 40px;
}
/deep/.el-select .el-select__caret {
  color: #000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Account.vue